import { Star, StarHalf, StarOutline, SvgIconComponent } from '@mui/icons-material';
import React from 'react';
import './StarRating.scss';

type StarRatingProps = {
  rating: number;
  maxStars?: number;
  size?: 'small' | 'medium' | 'large';
  showRatingText?: boolean;
};

function StarRating({
  rating,
  maxStars = 5,
  size = 'medium',
  showRatingText = false,
}: StarRatingProps) {
  const renderStar = (starIndex: number) => {
    const starValue = starIndex + 1;
    const ratingDifference = rating - starValue;

    // Determine which star icon to show based on rating
    let StarComponent: SvgIconComponent;
    if (ratingDifference >= 0) {
      StarComponent = Star; // Full star
    } else if (ratingDifference > -1) {
      StarComponent = StarHalf; // Half star
    } else {
      StarComponent = StarOutline; // Empty star
    }

    return (
      <div
        className={`star-icon ${size}`}
        key={starValue}
      >
        <StarComponent />
      </div>
    );
  };

  const stars = Array.from({ length: maxStars }, (_, index) => renderStar(index));

  return (
    <div className='star-rating-container'>
      {stars}
      {showRatingText && <span>({rating})</span>}
    </div>
  );
}

StarRating.displayName = 'StarRating';
export default StarRating;
